import React from "react";
import { motion } from "framer-motion";

// Word wrapper
const Wrapper = ({ children }) => {
  return <span className="word-wrapper">{children}</span>;
};

// Map API "type" values to JSX tag names
const tagMap = {
  paragraph: "p",
  heading1: "h1",
  heading2: "h2",
};

// AnimatedCharacters Component
const AnimatedCharacters = ({ text = "", type = "paragraph" }) => {
  // Framer Motion variant object, for controlling animation
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05, // Delay between characters
      },
    },
  };

  const item = {
    hidden: {
      y: "200%",
      color: "#0055FF",
      transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.85 },
    },
    visible: {
      y: 0,
      color: "#FF0088",
      transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.75 },
    },
  };

  // Ensure text is a string before attempting to split
  const splitWords = typeof text === "string" ? text.split(" ") : [];

  // Convert each word into an array of characters
  const words = splitWords.map((word) => [...word, "\u00A0"]);

  // Get the tag name from tagMap or default to "p"
  const Tag = tagMap[type] || "p";

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="visible"
      style={{ display: "inline-block" }} // Ensures correct animation alignment
    >
      <Tag>
        {words.map((word, wordIndex) => (
          <Wrapper key={wordIndex}>
            {word.map((char, charIndex) => (
              <span
                key={charIndex}
                style={{
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <motion.span
                  style={{ display: "inline-block" }}
                  variants={item}
                >
                  {char}
                </motion.span>
              </span>
            ))}
          </Wrapper>
        ))}
      </Tag>
    </motion.div>
  );
};

export default AnimatedCharacters;
